import { DAY_OF_WEEK } from "@dw/constants";
import { IAuditBase, FEE_TAX_SETTING } from "./shared";
import { Dayjs } from '@dw/dayjs'

export enum DANCE_STYLE {
  BALLET = "Ballet",
  CONTEMPORARY = "Contemporary",
  JAZZ = "Jazz",
  HIP_HIP = "HipHop",
  TAP = "Tap",
  MUSICAL_THEATRE = "MusicalTheatre",
  PRE_SCHOOL = "PreSchool"
}

export enum DANCE_CLASS_STATUS {
  ACTIVE = "Active",
  PLANNED = "Planned"
}

export interface IDanceClass extends IAuditBase {
  id: string;
  locationId: string;
  studioId: string;
  name: string;
  danceStyle: DANCE_STYLE;
  dayOfWeek: DAY_OF_WEEK;
  startTime: Dayjs;
  endTime: Dayjs;
  minAge?: number;
  maxAge?: number;
  fee: number;
  feeTaxSetting: FEE_TAX_SETTING;
  teacherUserIds: string[];
  inviteOnly: boolean;
  isDeleted: boolean;
  status: DANCE_CLASS_STATUS;
}

export interface IUpsertDanceClassRequest {
  locationId: string;
  studioId: string;
  name: string;
  danceStyle: DANCE_STYLE;
  dayOfWeek: DAY_OF_WEEK;
  startTime: string;
  endTime: string;
  minAge?: number;
  maxAge?: number;
  fee: number;
  feeTaxSetting: FEE_TAX_SETTING;
  teacherUserIds: string[];
  inviteOnly: boolean;
}

export interface ICreateDanceClassRequest extends IUpsertDanceClassRequest {
  confirmOverlap: boolean;
  status: DANCE_CLASS_STATUS;
}

export interface IUpdateDanceClassRequest extends ICreateDanceClassRequest {
  danceClassId: string;
}